// {{BASE_URL}}/api/schemeType
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

/** fetchRegistrationList  */
interface IDataItems {
  registration_status_id: number;
  registration_id: number;
  applicant_id: number;
  username: string;
  company_name: string;
  type: string;
  vat_number: number;
  verified: boolean;
  status: string;
  registration_date: string;
  commencement_date: string;
  change_date: string;
  state: string;
  canBeUpdated: number;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IRegistrationListOutput {
  items: IDataItems[];
  paging: IPaging;
}

interface IRegistrationListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  status?: string;
  state?: string;
  personal?: boolean;
}

export const fetchRegistrationList = async (
  payload: IRegistrationListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) searchQuery += `&vat_num=${payload.vat_num}`;
  if (payload.status) searchQuery += `&status=${payload.status}`;
  if (payload.state) searchQuery += `&state=${payload.state}`;
  if (payload.personal) searchQuery += `&personal=${payload.personal}`;
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/registration/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: IRegistrationListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
